import React, { Suspense } from 'react';
import { Route } from 'react-router-dom';

const Messages = React.lazy(() => import('./index'));
const MessageTable = React.lazy(() => import('./messageTable'));
const Message = React.lazy(() => import('./message'));
const MessageDetail = React.lazy(() => import('./messageDetail'));
const SendMessage = React.lazy(() => import('./sendMessage'));

export const useMessageRoutes = () => {

    return (
        <Route path="messages" element={<Suspense fallback={<div>منتظر باشید...</div>}><Messages /></Suspense>} >
            <Route index element={<Suspense fallback={<div>منتظر باشید...</div>}><MessageTable /></Suspense>} />
            <Route path="new" element={<Suspense fallback={<div>منتظر باشید...</div>}><SendMessage /></Suspense>} />
            <Route path=":recordId" element={<Suspense fallback={<div>منتظر باشید...</div>}><Message /></Suspense>} >
                <Route index element={<Suspense fallback={<div>منتظر باشید...</div>}><MessageDetail /></Suspense>} />
            </Route>
        </Route>
    )
}